angular.module('app.factories').factory('tasksListFilterFactory', ($translate, $state, $log, listFilter) => {
    const tasksListFilter = listFilter;

    tasksListFilter
        .setAttributes({
            name: 'tasksListFilter',
            providers: ['filterAreasOptions', 'categoryOptions', 'taskStatusOptions', 'usersOptions'],
        })
        .setFields({
            // row 1
            filter: {
                type: 'text',
                class: 'uk-width-medium-6-10',
                label: $translate.instant('search'),
                default: '',
            },
            search_in: {
                type: 'checkbox-list',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('search_in'),
                names: [
                    { name: 'name', label: $translate.instant('tasks.name') },
                    { name: 'interest.name', label: $translate.instant('tasks.interest_id') },
                    { name: 'client.name', label: $translate.instant('tasks.client_id') },
                    { name: 'notes', label: $translate.instant('tasks.notes') },
                ],
                default: { name: true },
            },

            // row 2
            area: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-10-10',
                label: $translate.instant('areas'),
                optionsProvider: 'filterAreasOptions',
                options: [],
                default: '',
            },

            // row 3
            date_from: {
                type: 'date',
                class: 'uk-width-medium-3-10',
                label: $translate.instant('filter.date_from'),
            },
            date_to: {
                type: 'date',
                class: 'uk-width-medium-3-10',
                label: $translate.instant('filter.date_to'),
            },
            category_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('tasks.category_id'),
                optionsProvider: 'categoryOptions',
                options: [],
                default: '',
            },

            // row 4
            status_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('tasks.status_id'),
                optionsProvider: 'taskStatusOptions',
                options: [],
                default: '',
            },
            author_id: {
                type: 'multiuserlist',
                operator: 'in',
                class: 'uk-width-medium-3-10',
                label: $translate.instant('tasks.author_id'),
                optionsProvider: 'usersOptions',
                options: [],
                default: '',
            },
            owner_id: {
                type: 'multiuserlist',
                operator: 'in',
                class: 'uk-width-medium-3-10',
                label: $translate.instant('tasks.owner_id'),
                optionsProvider: 'usersOptions',
                options: [],
                default: '',
            },
        })
        .onRefresh(() => {
            const filterParams = tasksListFilter.getValues(true);
            $log.debug('--> apply filter', filterParams);
            $state.applyFilter(filterParams);
        })
        .ready();

    return tasksListFilter;
});
